import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/motion/Reveal";
import SectionHeading from "@/components/SectionHeading";
import CTASection from "@/components/CTASection";
import { ArrowRight } from "lucide-react";

export default function Solutions() {
  const { t } = useLang();
  const s = t.solutions;

  return (
    <div data-testid="solutions-page">
      <section className="relative pt-40 pb-16 lg:pb-24 overflow-hidden">
        <div
          className="absolute -top-20 left-1/3 w-[600px] h-[600px] pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(0,229,255,0.10), transparent 60%)" }}
        />
        <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">
          <SectionHeading eyebrow={s.heroEyebrow} title={s.heroTitle} sub={s.heroSub} />
        </div>
      </section>

      {/* Detailed services */}
      <section className="pb-10">
        <div className="max-w-[1320px] mx-auto px-6 lg:px-10 space-y-6">
          {s.detail.map((d, i) => (
            <Reveal key={i} delay={0.05}>
              <div className="group border border-white/10 bg-navy-surface/40 p-8 lg:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8 hover:border-cyan-precision/40 transition-colors duration-300">
                <div className="lg:col-span-5">
                  <span className="font-mono-tech text-[12px] uppercase tracking-widest text-cyan-precision">
                    {d.tag}
                  </span>
                  <h3 className="mt-5 font-display text-3xl lg:text-4xl font-light tracking-tight text-[#F0F4F8] leading-tight">
                    {d.title}
                  </h3>
                  <p className="mt-5 text-[#94A3B8] leading-relaxed text-lg">{d.desc}</p>
                </div>
                <div className="lg:col-span-7 lg:border-l lg:border-white/10 lg:pl-12">
                  <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
                    {d.points.map((p, j) => (
                      <li key={j} className="flex items-start gap-3 text-[#F0F4F8]/85">
                        <ArrowRight size={16} className="mt-1 shrink-0 text-cyan-precision" />
                        <span className="leading-relaxed">{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Engagement model */}
      <section className="py-28 lg:py-36 border-t border-white/10">
        <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
          <SectionHeading title={s.processTitle} />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-4 gap-6">
            {s.process.map((p, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="relative h-full border border-white/10 bg-navy-surface/40 p-8 hover:-translate-y-1 hover:border-cyan-precision/50 transition-all duration-300">
                  <div className="font-mono-tech text-5xl font-bold text-[#F0F4F8]/10">0{i + 1}</div>
                  <h4 className="mt-4 font-display text-2xl font-light text-[#F0F4F8]">{p.t}</h4>
                  <p className="mt-3 text-sm text-[#94A3B8] leading-relaxed">{p.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection title={s.ctaTitle} body={s.ctaBody} btn={s.ctaBtn} />
    </div>
  );
}
